import React from 'react';
import { DefaultAction } from './actions/default';
import { RejectAction } from './actions/rejects';
import { TransferAction } from './actions/transfer';
import { AgreeAction } from './actions/open-product-last-step/agree';
import { AgreeAddApproveAction } from './actions/open-product-last-step/agree-add-approve';
import { ProcessCatStore } from '../store';
import { ISubmitActionsProps } from './actions';

export const SubmitActionsOpenProductLastStep: React.FC<ISubmitActionsProps> = ({
    currentAction,
    data,
    onOk,
    onCancel,
    defaultStore,
    loading,
}) => {
    return (
        <>
            <DefaultAction
                {...{ currentAction, data, onOk, onCancel, loading }}
            />
            <RejectAction
                {...{ currentAction, data, onOk, onCancel, loading }}
            />
            <TransferAction
                {...{
                    currentAction,
                    data,
                    onOk,
                    onCancel,
                    defaultStore,
                    loading,
                }}
            />
            <AgreeAction
                {...{
                    currentAction,
                    data,
                    onOk,
                    onCancel,
                    defaultStore,
                    loading,
                }}
            />
            <AgreeAddApproveAction
                {...{
                    currentAction,
                    data,
                    onOk,
                    onCancel,
                    defaultStore,
                    loading,
                }}
            />
        </>
    );
};
